import React from "react";
import { useNavigate } from "react-router-dom";

const IRISIntroComponent = () => {
  const navigate = useNavigate();

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "32px 24px",
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    backgroundColor: "#ffffff",
    color: "#1a1a1a",
    lineHeight: "1.6",
  };

  const headerStyle = { marginBottom: "40px" };
  const headerTopStyle = { display: "flex", alignItems: "baseline", gap: "16px" };
  const logoStyle = { fontSize: "2.8rem", fontWeight: "800", color: "#f57c00", letterSpacing: "-1px" };
  const titleStyle = { margin: 0, fontSize: "2.4rem", fontWeight: "700" };
  const releaseStyle = { color: "#555", fontWeight: "500", marginTop: "4px", fontSize: "1.1rem" };
  const sectionStyle = { marginBottom: "48px" };
  const h2Style = { color: "#0d47a1", borderBottom: "2px solid #e0e0e0", paddingBottom: "8px", marginBottom: "1.2em", fontSize: "1.8rem" };
  const tocGridStyle = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "32px" };
  const tocListStyle = { backgroundColor: "#f8f9fa", border: "1px solid #e0e0e0", borderRadius: "8px", padding: "20px" };
  const tocItemStyle = {
    padding: "12px 16px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "6px",
    transition: "all 0.15s ease",
    backgroundColor: "transparent",
    color: "#333",
    fontWeight: "500",
  };
  const tocItemHoverStyle = { backgroundColor: "#e3f2fd", color: "#0d47a1", fontWeight: "600" };
  const arrowStyle = { fontSize: "1.1em", fontWeight: "bold", color: "#666" };
  const previewStyle = { backgroundColor: "#e8f5e9", borderLeft: "4px solid #2e7d32", padding: "24px", borderRadius: "4px" };
  const linkStyle = { color: "#0d47a1", textDecoration: "none", borderBottom: "1px solid #0d47a1", transition: "all 0.2s" };

  const goToDetail = (path) => {
    navigate(path, { replace: true });
  };

  return (
    <div style={containerStyle}>
      {/* Header */}
      <header style={headerStyle}>
        <div style={headerTopStyle}>
          <div style={logoStyle}>IRIS+</div>
          <h1 style={titleStyle}>IRIS 5.3a Catalog of Metrics</h1>
        </div>
        <p style={releaseStyle}>Released December 2024</p>
      </header>

      {/* Introduction */}
      <section style={sectionStyle}>
        <h2 style={h2Style}>About IRIS 5.3a</h2>

        <p>
          Throughout 2018 and 2019, the GIIN, with the contribution of over 850
          stakeholders, evolved IRIS — which since 2008 had exclusively been a
          catalog of standardized social and impact performance metrics most
          widely used by impact investors worldwide — into{" "}
          <strong>IRIS+</strong>, the generally accepted system for measuring,
          managing, and optimizing impact.
        </p>

        {/* ... rest of the introduction text remains the same ... */}
      </section>

      {/* Table of Contents */}
      <section style={sectionStyle}>
        <h2 style={h2Style}>Table of Contents</h2>

        <div style={tocGridStyle}>
          <div style={tocListStyle}>
            <div
              style={tocItemStyle}
              onClick={() => goToDetail("/reporting/iris/iris-giin-compliance-matrix/iris-system-kpi-proj-entities/IRISComponentsTable")}
              onMouseEnter={(e) => Object.assign(e.currentTarget.style, tocItemHoverStyle)}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = "#333";
                e.currentTarget.style.fontWeight = "500";
              }}
            >
              <span>The components of IRIS 5.3a Catalog of Metrics</span>
              <span style={arrowStyle}>→</span>
            </div>

            <div
              style={tocItemStyle}
              onClick={() => goToDetail("/reporting/iris/iris-giin-compliance-matrix/iris-system-kpi-proj-entities/MetricsCatalogTable")}
              onMouseEnter={(e) => Object.assign(e.currentTarget.style, tocItemHoverStyle)}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = "#333";
                e.currentTarget.style.fontWeight = "500";
              }}
            >
              <span>IRIS 5.3a — The complete Catalog of Metrics</span>
              <span style={arrowStyle}>→</span>
            </div>

            <div
              style={tocItemStyle}
              onClick={() => goToDetail("/reporting/iris/iris-giin-compliance-matrix/iris-system-kpi-proj-entities/IRISGlossaryTable")}
              onMouseEnter={(e) => Object.assign(e.currentTarget.style, tocItemHoverStyle)}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = "#333";
                e.currentTarget.style.fontWeight = "500";
              }}
            >
              <span>Glossary</span>
              <span style={arrowStyle}>→</span>
            </div>

            <div
              style={tocItemStyle}
              onClick={() => goToDetail("/reporting/iris/iris-giin-compliance-matrix/iris-system-kpi-proj-entities/IRISReferenceLists")}
              onMouseEnter={(e) => Object.assign(e.currentTarget.style, tocItemHoverStyle)}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = "#333";
                e.currentTarget.style.fontWeight = "500";
              }}
            >
              <span>Reference Lists</span>
              <span style={arrowStyle}>→</span>
            </div>
          </div>

          {/* Preview Area */}
          <div style={previewStyle}>
            <h3 style={{ marginTop: 0, color: "#1b5e20" }}>Explore IRIS 5.3a</h3>
            <p>Click on any section above to view detailed information.</p>
            <p>Each section is available on its own dedicated page for better navigation and focus.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IRISIntroComponent;